import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function DeleteFoodStockCase(foodStockRepository: FoodStockRepository) {
  return async function (foodStockId: string) {
    return await foodStockRepository.deleteFoodStock(foodStockId)
  }
}
